import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "fill-circle-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("circle", { cx: 8, cy: 8, r: 3, fill: "currentColor", fillRule: "evenodd" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
